import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useAppState } from "../../context/appStateContext";
import { useLicense } from "../../context/licenseContext";
import { TutorialProvider } from "../../context/tutorialContext";
import TutorialOverlay from "../ui/TutorialOverlay";
import LoginOverlay from "../LoginOverlay/LoginOverlay";
import Menu from "../Menu/Menu";
import Header from "../Header/header";
import MobileHeader from "../MobileHeader/mobileHeader";
import COAProgressBar from "../COAProgressBar/COAProgressBar";
import apiClient from "../../api/apiClient";

export default function ProtectedLayout() {
    const {
        user, userId, userProfile, company, given_name, title,
        licenseNo, headerAndMenu, headerTitle, setHeaderAndMenu,
        setHeaderTitle, profilePicUrl, coaProcessing, sessionExpired, completeLogin,
    } = useAppState();
    const { currentLicense } = useLicense();
    const [permissions, setPermissions] = useState(() => {
        try {
            const saved = localStorage.getItem("currentPermissions");
            return saved ? JSON.parse(saved) : null;
        } catch {
            return null; 
        }
    });
  
    const isAuthenticated = !!user;
    useEffect(() => {
        if (!isAuthenticated || !currentLicense?.licenseNo) return;
        apiClient
            .get(`/permissions/my-permissions?licenseNo=${currentLicense.licenseNo}`)
            .then((res) => {
                setPermissions(res.data);
                localStorage.setItem("currentPermissions", JSON.stringify(res.data));
            })
            .catch(() => setPermissions(null));
    }, [isAuthenticated, currentLicense?.licenseNo]);

    if (!user && !userId && !sessionExpired) return <LoginOverlay onLoginSuccess={completeLogin} />;

    return (
        <TutorialProvider permissions={permissions}>
            {headerAndMenu && (
                <>
                    <Menu
                        userId={userId}
                        userProfile={userProfile}
                        company={company}
                        givenName={given_name}
                        title={title}
                        licenseNo={licenseNo}
                        headerTitle={headerTitle}
                        coaProcessing={coaProcessing}
                    />
                    <Header
                        userId={userId}
                        userProfile={userProfile}
                        company={company}
                        givenName={given_name}
                        PROFILE_URL={profilePicUrl}
                        setHeaderAndMenu={setHeaderAndMenu}
                        headerTitle={headerTitle}
                        setHeaderTitle={setHeaderTitle}
                        title={title}
                        licenseNo={licenseNo}
                        coaProcessing={coaProcessing}
                    />
                    <MobileHeader
                        userId={userId}
                        headerTitle={headerTitle}
                        userProfile={userProfile}
                    />
                </>
            )}
            {coaProcessing && <COAProgressBar />}
            <TutorialOverlay />
            <Outlet />
            {(!user || sessionExpired) && <LoginOverlay onLoginSuccess={completeLogin} />}
        </TutorialProvider>
    );
}
